import React from 'react'
import { Boost } from '../../../components'
const ModalContent = ({ onModalClose, card, onCardBoosted }) => {
  return (
    <div>
      <Boost onCardBoosted={onCardBoosted} onModalClose={onModalClose} card={card} />
    </div>
  )
}
export default ModalContent